var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocument(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6663 1.89062V5.33274C11.6663 5.79945 11.6663 6.03281 11.7572 6.21107C11.8371 6.36787 11.9645 6.49535 12.1213 6.57525C12.2996 6.66607 12.533 6.66607 12.9997 6.66607H16.4418M13.333 10.8327H6.66634M13.333 14.166H6.66634M8.33301 7.49935H6.66634M11.6663 1.66602H7.33301C5.93288 1.66602 5.23281 1.66602 4.69803 1.9385C4.22763 2.17818 3.84517 2.56063 3.60549 3.03104C3.33301 3.56582 3.33301 4.26588 3.33301 5.66602V14.3327C3.33301 15.7328 3.33301 16.4329 3.60549 16.9677C3.84517 17.4381 4.22763 17.8205 4.69803 18.0602C5.23281 18.3327 5.93288 18.3327 7.33301 18.3327H12.6663C14.0665 18.3327 14.7665 18.3327 15.3013 18.0602C15.7717 17.8205 16.1542 17.4381 16.3939 16.9677C16.6663 16.4329 16.6663 15.7328 16.6663 14.3327V6.66602L11.6663 1.66602Z",
    stroke: "#374562",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocument);
export default __webpack_public_path__ + "static/media/document.c4e8697787dfad05d109aeec37b62d83.svg";
export { ForwardRef as ReactComponent };